<template>
  <section class="content-wrapper__container" v-if="options['Learn about our Services']">
    <div class="content-wrapper" v-for="item in options['Learn about our Services']['Learn about our Services']" :class="{ 'image-left': content.imagePosition === 'left', 'image-right': content.imagePosition === 'right' }">
      <div class="text-content">
        <h2>{{ item.title }}</h2>
        <p>{{ item.text }}</p>
        <a :href="item.link">{{ item.button_text }}
          <svg width="20.000000" height="20.000000" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
               <defs>
                  <clipPath id="clip13_744">
                      <rect id="Arrows Links" rx="0.000000" width="19.000000" height="19.000000" transform="translate(0.500000 0.500000)" fill="white" fill-opacity="0"/>
                  </clipPath>
              </defs>
              <rect id="Arrows Links" rx="0.000000" width="19.000000" height="19.000000" transform="translate(0.500000 0.500000)" fill="#FFFFFF" fill-opacity="0"/>
              <g clip-path="url(#clip13_744)">
                  <path id="Union" d="M15.74 9.42L12.02 5.81L12.86 5L17.58 9.59L18 10L17.58 10.4L12.86 15L12.02 14.18L15.74 10.57L3 10.57L3 9.42L15.74 9.42Z" fill="#050505" fill-opacity="1.000000" fill-rule="evenodd"/>
              </g>
          </svg>
      </a>
      </div>
      <div class="image-content">
        <img :src="`${this.$store.state.base_directory}${item.image.replace(/^public\//, '')}`" alt="Изображение">
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    content: {
      type: Object,
      required: true,
      default: () => ({
        imagePosition: 'right',
      }),
    },
  },
  computed: {
    options() {
            return this.$store.state.options;
        },
    }
};
</script>

<style scoped>

.content-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  background: linear-gradient(180.00deg, rgb(173, 184, 199),rgb(222, 230, 234) 100%);
  padding: 51px 64px;
  width: 100%;
  margin-top: 242px;
}

.text-content {
  width: 42%;
  z-index: 2;
}

.text-content h2 {
  color: rgb(5, 5, 5);
  font-size: 44px;
  font-weight: 500;
  line-height: 140%;
  letter-spacing: 0%;
  padding-bottom: 24px;
}

.text-content p {
  color: rgb(5, 5, 5);
  font-size: 16px;
  font-weight: 400;
  line-height: 140%;
  letter-spacing: 0%;
  padding-bottom: 24px;
  max-width: 342px;
}
.text-content a{
  display: flex;
  align-items: center;
  gap: 8px;
  color: rgb(5, 5, 5);
  font-size: 16px;
  font-weight: 500;
  line-height: 140%;
  letter-spacing: 0%;
  text-align: left;
  text-decoration: underline;
}
.action-button {
  padding: 12px 32px;
  font-size: 16px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.3s ease;
}

.action-button:hover {
  background-color: #0056b3;
}

.image-content {
  position: absolute;
  max-height: 447px;
  width: auto;
  bottom: 0;
  z-index: 1;
}

.image-content img {
  height: 100%;
  max-height: 447px;
  width: auto;
}

/* Расположение изображения слева, текст справа */
.image-left .text-content {
  margin-left: auto;
}

.image-left .image-content {
  left: 0;
}

/* Расположение изображения справа, текст слева */
.image-right .text-content {
  margin-right: auto;
}

.image-right .image-content {
  right: 0;
}
@media (max-width: 1100px) {
  .image-content img{
    width: 90%;
  }
}
@media (max-width: 1024px) {
.content-wrapper {
  flex-direction: column;
  align-items: flex-start;
  padding: 40px 20px;
  margin-top: 140px;
}
.image-left .text-content{
  margin-left: unset;
}
.text-content {
  width: 100%;
  max-width: 80%;
}
.text-content h2{
  font-size: 32px;
}
.image-content {
  position: static;
  width: 100%;
  max-height: none;
  text-align: center;
}

.image-content img {
  width: 100%;
  height: auto;
  object-fit: contain;
}

.text-content a {
  bottom: unset;
  top: 40px;
  right: 20px;
}
}
@media (max-width: 768px) {
.image-content img{
  width: 90%;
}
.text-content h2{
  font-size: 24px;
}
.text-content p{
  font-size: 18px;
}
.arrow__link{
  width: 56px;
  height: 56px;
}
.content-wrapper{
  margin-top: unset;
  padding-bottom: unset;
  
}
.image-content{
  display: flex;
  justify-content: center;
}
}
</style>
